export const MAX_PRODUCT_UOM = 4294967295;

export const validateProductUom = (value) => {
  const text = value.trim();
  if (!text) return "";
  if (!/^[0-9]+$/.test(text)) return "UOM must be a whole number.";
  if (!Number.isSafeInteger(Number(text)) || Number(text) > MAX_PRODUCT_UOM) {
    return `UOM must be between 0 and ${MAX_PRODUCT_UOM}.`;
  }
  return "";
};
